<template>
  <v-dialog v-model="visible" persistent max-width="638">
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <form class="form--custom" novalidate @submit.prevent="deleteEmployees">
        <v-card-text class="px-4 pt-0 pb-2">
          <label>{{ $t(`${namespace}.form.fieldIDsLabel`) }}</label>
          <v-textarea
            v-model="form.ids"
            :placeholder="$t(`${namespace}.form.fieldIDsPlaceholder`)"
            v-validate="{ required: true }"
            :error-messages="errors.collect($t(`${namespace}.form.fieldIDsName`))"
            :data-vv-name="$t(`${namespace}.form.fieldIDsName`)"
            flat
            outline
            solo
            color="accent"
            @keyup="normalizeIDs"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer/>

          <a
            v-if="!isLoading"
            href="#"
            class="text--normal accent--text mr-4"
            color="accent"
            flat
            round
            @click.prevent="close(null)"
          >
            {{ $t('Common.cancel') }}
          </a>

          <v-btn
            type="submit"
            :loading="isLoading"
            :disabled="isLoading"
            color="accent"
            depressed
            round
          >
            {{ $t(`${namespace}.submitButton`) }}
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ExcludeEmployeesByIDDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      namespace: 'Views.EmployeesPage.deleteEmployeesDialog',
      isLoading: false,
      form: {
        ids: ''
      }
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    close (reload = null) {
      this.$emit('close', reload)
    },

    normalizeIDs () {
      this.form.ids = this.form.ids
        .replace(/[^\d,]/g, '')
        .replace(/,+/g, ',')
        // .replace(/,+$/, '')
    },

    async deleteEmployees () {
      const isValid = await this.$validator.validateAll()

      if (!isValid) return

      this.isLoading = true

      try {
        const companyId = this.selectedCompany.id
        const ids = this.form.ids
          .split(',')
          .filter(id => Boolean(id))
          .map(id => Number(id))

        await this.$apiService.employeeMultiDeleteById(companyId, { ids })

        this.close(true)
        this.$emit('reloadData')
        this.showAlert({
          type: 'success',
          message: 'Colaboradores excluídos com sucesso'
        })
      } catch (error) {
        const employeeIDsWithError = error && error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors
          : []
        const message = error && error.response && error.response.data && error.response.data.data
          ? this.$t(`${this.namespace}.error`).replace('[VAL]', employeeIDsWithError.join(', '))
          : this.$t('Common.genericError')

        this.showAlert({
          type: 'error',
          message,
          timeout: 8000
        })
      }

      this.isLoading = false
    }
  }
}
</script>
